import React from 'react';
import './Solution.css';
import { useComponentAnalytics } from '../hooks/useAnalytics';

const Solution = () => {
  const { trackInteraction } = useComponentAnalytics('Solution');

  const components = [
    {
      icon: '📥',
      title: 'Ingesta Automática de Fuentes',
      description: 'Confluence, Jira, Git, CSVs, etc.',
      details: [
        'Conectores nativos pre-configurados',
        'Sincronización en tiempo real',
        'Procesamiento inteligente de datos'
      ]
    },
    {
      icon: '🤖',
      title: 'Agentes Especializados',
      description: 'Entienden contexto y roles',
      details: [
        'QA Engineer, Project Manager, DevOps',
        'Configurables según necesidades',
        'Aprenden del uso y mejoran continuamente'
      ]
    },
    {
      icon: '🔧',
      title: 'Herramientas Inteligentes',
      description: 'Conectadas vía API',
      details: [
        'Integración con n8n, Zapier',
        'Microservicios propios',
        'Funciones externas personalizadas'
      ]
    },
    {
      icon: '⚙️',
      title: 'Backoffice de Control',
      description: 'Roles y uso configurables',
      details: [
        'Límites de tokens por perfil',
        'Control de tono y vocabulario',
        'Fuentes habilitadas por rol',
        'Gestión de prompts'
      ]
    }
  ];

  const handleComponentHover = (componentTitle) => {
    trackInteraction('solution_component_hover', 'component', {
      component_title: componentTitle
    });
  };

  return (
    <section id="solucion" className="solution section">
      <div className="container">
        <div className="solution-header">
          <h2 className="section-title">Nuestra Solución</h2>
          <p className="section-subtitle">
            Una plataforma segura y escalable de IA corporativa, basada en agentes configurables, 
            que centraliza, estructura y controla el uso de inteligencia artificial en las empresas.
          </p>
        </div>

        <div className="solution-main">
          <div className="solution-visual">
            <div className="platform-diagram">
              <div className="diagram-center">
                <div className="center-icon">🧠</div>
                <h4>ExpertMind<br/>Platform</h4>
              </div>
              <div className="diagram-connections">
                <div className="connection-line line-1"></div>
                <div className="connection-line line-2"></div>
                <div className="connection-line line-3"></div>
                <div className="connection-line line-4"></div>
              </div>
            </div>
          </div>

          <div className="solution-content">
            <h3 className="solution-subtitle">Componentes Clave:</h3>
            <div className="components-list">
              {components.map((component, index) => (
                <div 
                  key={index} 
                  className="component-item fade-in-up"
                  style={{ animationDelay: `${index * 0.1}s` }}
                  onMouseEnter={() => handleComponentHover(component.title)}
                >
                  <div className="component-header">
                    <span className="component-icon">{component.icon}</span>
                    <div className="component-title-group">
                      <h4 className="component-title">{component.title}</h4>
                      <p className="component-description">{component.description}</p>
                    </div>
                  </div>
                  <ul className="component-details">
                    {component.details.map((detail, idx) => (
                      <li key={idx}>
                        <span className="detail-bullet">✓</span>
                        {detail}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="solution-benefits">
          <h3 className="benefits-title">¿Qué logras con ExpertMind?</h3>
          <div className="benefits-grid">
            <div className="benefit-item">
              <div className="benefit-icon">🎯</div>
              <h4>Información Centralizada</h4>
              <p>Todo tu conocimiento empresarial en un solo lugar, accesible y actualizado</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">🔒</div>
              <h4>IA Segura y Controlada</h4>
              <p>Uso de inteligencia artificial con gobernanza, auditoría y sin fugas de datos</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">⚡</div>
              <h4>Decisiones Más Rápidas</h4>
              <p>Respuestas instantáneas basadas en todo el contexto de tu organización</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">📈</div>
              <h4>Escalabilidad Real</h4>
              <p>Crece sin multiplicar recursos ni costos operacionales</p>
            </div>
          </div>
        </div>

        <div className="solution-cta">
          <div className="cta-box">
            <h3>¿Quieres ver ExpertMind en acción?</h3>
            <p>Agenda una demo personalizada y descubre cómo transformar tu empresa</p>
            <a href="#contacto" className="btn btn-primary btn-large">
              <span>Solicitar Demo</span>
              <span className="btn-icon">→</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Solution;
